import React from "react";
import ATAQUES from "../seguridad/ataques";
import ARQUITECTURAS from "../seguridad/todas";
import { TERMINOS } from "../glosario";
import { normalizar } from "../utilGuia";

// Resultados de la busqueda fuera de los servicios: arquitecturas, amenazas y terminos del glosario
export const buscarGlobal = (q) => {
    const n = normalizar(q);
    if (n.length < 2) return { arquitecturas: [], amenazas: [], terminos: [] };
    const tiene = (...t) => normalizar(t.join(" ")).includes(n);
    return {
        arquitecturas: ARQUITECTURAS.filter(a => tiene(a.titulo, a.descripcion, a.categoria)).slice(0, 6),
        amenazas: ATAQUES.filter(a => tiene(a.titulo, a.que, a.categoria)).slice(0, 6),
        terminos: TERMINOS.filter(t => tiene(t.t, t.d)).slice(0, 6),
    };
};

const BusquedaGlobal = ({ q, onArquitectura, onAmenaza }) => {
    const r = buscarGlobal(q);
    if (!r.arquitecturas.length && !r.amenazas.length && !r.terminos.length) return null;
    return (
        <div className="border-top pt-2 mt-2" data-guia="busqueda-global">
            <div className="fw-bold small mb-1"><i className="fa fa-search-plus me-1" />También en la guía</div>
            {r.arquitecturas.length > 0 && <div className="small text-muted">Arquitecturas</div>}
            {r.arquitecturas.map(a => <button key={a.id} className="btn btn-sm btn-link d-block text-start py-0" onClick={() => onArquitectura(a.id)}><i className={`${a.icono} me-1`} />{a.titulo}</button>)}
            {r.amenazas.length > 0 && <div className="small text-muted mt-1">Amenazas</div>}
            {r.amenazas.map(a => <button key={a.id} className="btn btn-sm btn-link d-block text-start py-0" onClick={() => onAmenaza(a.id)}><i className="fa fa-user-secret me-1" />{a.titulo}</button>)}
            {r.terminos.length > 0 && <div className="small text-muted mt-1">Glosario</div>}
            {r.terminos.map(t => <details key={t.t} className="small"><summary>{t.t}</summary><div className="text-muted ms-3">{t.d}</div></details>)}
        </div>
    );
};

export default BusquedaGlobal;
